import React, { useState } from 'react';
import { toast } from 'sonner';
import { api } from '@/lib/api';
import { Diamond, CurrencyDollar } from '@phosphor-icons/react';

/**
 * MemoryCrystalButton — $5 Stripe checkout to preserve a Scene with
 * a Claude-generated 30-word flourish. Only owners of bubbles inside
 * the scene can buy. Used inline under EncounterScene.
 */
const MemoryCrystalButton = ({ scene }) => {
  const [busy, setBusy] = useState(false);
  const buy = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/scenes/${scene.id}/memory-crystal/buy`, {
        scene_id: scene.id,
        origin_url: window.location.href,
      });
      window.location.href = data.checkout_url;
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'could not preserve');
      setBusy(false);
    }
  };
  return (
    <button
      data-testid="memory-crystal-buy"
      onClick={buy}
      disabled={busy}
      title="Preserve this scene forever — $5"
      className="ml-1 inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-bx-cyan/15 hover:bg-bx-cyan/25 text-bx-cyan text-[11px] font-bold uppercase tracking-widest disabled:opacity-50"
    >
      <Diamond size={12} weight="fill" /> preserve · $5
    </button>
  );
};

export default MemoryCrystalButton;
